import { call, put, takeEvery } from 'redux-saga/effects'
import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'
import { renderErrorNotification } from '../../helpers/apiHelpers'

export function* loadCustomers(action) {
  try {
    const payload = action.payload || {}

    if (!payload.skipLoading) {
      yield put({ type: 'SET_LOADING' })
      yield put({ type: 'UNSET_LOADING_ERROR' })
    }

    api.setAuthApi({
      'Authorization': sessionHelpers.getApplicationCookie('authentication_token')
    })

    yield put({ type: 'CUSTOMERS_LOAD_REQUESTED' })

    const request = {
      url: '/customers',
      body: { id: Array.from(new Set(payload.customerIds)) }
    }

    const response = yield call(api.utility.get, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'CUSTOMERS_LOAD_SUCCEEDED',
      payload: {
        data: response.body
      }
    })

    if (!payload.skipLoading) yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    yield put(renderErrorNotification(`Error loading Customer data: ${apiErrorHelpers.toString(errors)}`))

    apiErrorHelpers.consoleLog(errors)
  }
} // loadCustomers

export default function* customerSaga() {
  yield takeEvery('CUSTOMERS_LOAD_SAGA', loadCustomers)
}
